<template>
  <div class="position-absolute bottom-0 end-0 m-5" style="max-width: 400px" v-if="isReviewModalVisible">
    <div class="rounded bg-white shadow-lg py-4 px-5 border-top border-5 border-primary">
      <div class="d-flex flex-column justify-content-center align-items-center">
        <button @click="postponeReviewModal()"
                class="btn btn-sm btn-close position-absolute top-0 end-0 me-3 mt-3"></button>
        <div class="fs-3 text-warning mb-3"><span class="material-icons">star_rate</span><span
            class="material-icons">star_rate</span><span
            class="material-icons">star_rate</span><span
            class="material-icons">star_rate</span><span
            class="material-icons">star_rate</span>
        </div>
        <p class="text-center text-muted mb-4">Help us spread the word and motivate the team
          behind Mantiq to deliver more!</p>
        <a target="_blank"
           href="https://wordpress.org/support/plugin/mantiq/reviews/?filter=5#new-post"
           class="btn btn-primary"
           @click="collectReviewModal()">Write a Review</a>
        <button class="btn btn-sm text-muted mt-2" tabindex="0" @click="postponeReviewModal()">Maybe later</button>
      </div>
    </div>
  </div>
</template>

<script>
import {reactive} from "vue";
import * as deepmerge from 'deepmerge';

export default {
  name: "Reminders",
  setup() {
    const STORE_KEY = 'mantiq_marketing';
    const DAYS_TO_REVIEW = 2;

    const retrieve = () => {
      let state = deepmerge(
          {
            review: {
              collected: false,
              last_requested_at: null,
            },
          },
          JSON.parse(localStorage.getItem(STORE_KEY) || '{}')
      );

      Object.defineProperty(state.review, 'visible', {
        get: function () {
          return !this.collected && this.last_requested_at && (Date.now() - this.last_requested_at) > (DAYS_TO_REVIEW * 24 * 60 * 60 * 1000)
        },
        enumerable: false
      });

      return state;
    };
    const persist = () => localStorage.setItem(STORE_KEY, JSON.stringify(state));
    const state = reactive(retrieve());

    const checkReviewState = () => {
      if (state.review.last_requested_at === null) {
        postponeReviewModal();
      }
    };
    const postponeReviewModal = () => {
      state.review.last_requested_at = Date.now();
      persist();
    };
    const collectReviewModal = () => {
      state.review.collected = true;
      state.review.last_requested_at = Date.now();
      persist();
    }

    checkReviewState();

    return {
      postponeReviewModal,
      collectReviewModal,
      get isReviewModalVisible() {
        return state.review.visible;
      }
    };
  }
}
</script>
